<template>
<div class="popup" v-show="optionDialogShow" v-cloak>
    <div class="content" id="transferOptions">
        <div class="title">
            {{$t('language.common.options')}}
            <div class="icon white-close dialog-close" @click="optionClose()"></div>
        </div>
        <div class="transfer-options-body">
            <div class="transfer-options-cont">
                <el-tabs v-model=activeName>
                    <el-tab-pane :label="$t('language.emailTransfer.migrationSetting')" name="first">
                        <tab1 ref="tab1" ></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.emailTransfer.notification')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="transfer-options-footer">
                <button style="float:right;" @click="optionSubmit()">{{$t('language.common.save')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/transfer_options.css'
import tab1 from "@/components/common/tabs/tabs_transfer_options/tab_email_transfer";
import tab2 from "@/components/common/tabs/tabs_transfer_options/tab_email";
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    components: {
        tab1,
        tab2,
    },
    data: function () {
        return {
            activeName: "first",
            optionDialogShow: false,
            tabs: [{
                name: this.$t('language.cloudTransfer.transfer')
            }, {
                name: this.$t('language.popup.email')
            }, {
                name: this.$t('language.popup.filter')
            }],
            indexCurrent: 0,
            tabBarClass: '',
            options: {
                replace: 4,
                isRemove: 0,
                isKeep: 0,
                isChar: 1,
            },
            oldOptions: {},
            source:'',//弹窗来源
        };
    },
    watch:{
    },
    methods: {
        init(options) {
            this.optionDialogShow = true;
            this.options = options;
            this.$refs.tab1.isSaveAtt = this.options.attachment;
            this.$refs.tab1.isConver = this.options.conversationQuoted;
            this.$refs.tab1.isSaveOnly = this.options.onlyLastMail;
            this.$refs.tab1.isChar = this.options.isChar;
            this.$refs.tab1.replace = this.options.replace;
        },
        optionSubmit() {
            let user = commonUtils.getUser();
            this.options = this.$parent.pOptions;
            //当用户勾选了邮箱但没有填邮箱
            if (!this.$refs.tab2.email && this.$refs.tab2.sendShow) {
                this.indexCurrent = 1;
                this.activeName = 'second';
                this.$refs.tab2.shakeBox = "email-shake";
                setTimeout(() => {
                    this.$refs.tab2.shakeBox = "box-shakeOrigin";
                }, 200);
            } else {
                if (this.$refs.tab2.email) {
                    if (!commonstate.emailpattern.test(this.$refs.tab2.email)) {
                        this.activeName = 'second';
                        this.$toast({
                            text: this.$t('language.login.enterCorrectEmai'),
                            type: 'fail',
                            idValue: "transferOptions"
                        });
                        return false;
                    }
                    this.options.email = this.$refs.tab2.email;
                } else {
                    delete this.options.email;
                }
                this.options.attachment = this.$refs.tab1.isSaveAtt;
                this.options.conversationQuoted = this.$refs.tab1.isConver;
                this.options.onlyLastMail = this.$refs.tab1.isSaveOnly;
                this.options.isChar = this.$refs.tab1.isChar;
                this.options.replace = this.$refs.tab1.replace;
                this.$parent.pOptions = Object.assign({}, this.options);
                this.optionDialogShow = false;
                //对旧数据进行拷贝
                this.oldOptions = Object.assign({}, this.options);
            }
        },
        optionClose() {
            let that = this;
            let suffix;
            //还原tab1用户之前选择的数据
            this.optionDialogShow = false;
            this.$refs.tab1.isSaveAtt = true;
            this.$refs.tab1.isConver = true;
            this.$refs.tab1.isSaveOnly = false;
            this.$refs.tab1.isChar = 1;
            this.$refs.tab1.replace = 4;
            //还原tab2用户之前选择的数据
            if (this.oldOptions.email) {
                this.$refs.tab2.sendShow = true;
                this.$refs.tab2.email = this.oldOptions.email;
            } else {
                this.$refs.tab2.sendShow = false;
                this.$refs.tab2.email = "";
            }
        },
        clearAllData() {
            this.oldOptions={};
            this.$parent.pOptions = {
                replace: 4,
                isChar: 1,
                keepRoot:1,
                attachment: true,
                conversationQuoted: true,
                onlyLastMail: false,
                way: "cloudEmail",
            };
            this.activeName = 'first';
            this.$refs.tab2.sendShow = false;
            this.$refs.tab2.email = '';
            this.$refs.tab1.init();
        }
    }
};
</script>

<style>
#transferOptions #tab-first,
#transferOptions #tab-second {
    font-size: 14Px;
    height: 40Px;
    line-height: 40Px;
    position: relative;
}

#transferOptions #tab-third {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    line-height: 40Px;
}

#tab-second {
    margin-left: 0 !important;
}

.is-top {
    margin: 0 !important;
}

#transferOptions .el-tabs__content {
    height: 350px;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    overflow: visible;

}
</style>




// WEBPACK FOOTER //
// src/components/popup/email_transfer_popups/transfer_options_popup.vue